/**
 * Creator dashboard tutorial popup.
 *
 * The server already decided whether this modal exists at all, so the only
 * decisions here are when to open it, keeping the player from running in the
 * background once it is closed, and persisting "Don't show this again".
 *
 * The checkbox is saved when the modal closes rather than on every toggle: the
 * creator can change their mind while the video plays, and one request at the
 * end is what they actually meant.
 */
function initCreatorTutorial() {
  const modal = document.querySelector('[data-creator-tutorial]');
  if (!modal || !window.bootstrap) return;

  const endpoint = modal.dataset.creatorTutorialEndpoint;
  const optOut = modal.querySelector('[data-creator-tutorial-optout]');
  const confirmButton = modal.querySelector('[data-creator-tutorial-confirm]');
  const video = modal.querySelector('[data-creator-tutorial-video]');
  const frame = modal.querySelector('[data-creator-tutorial-frame]');

  let dismissSent = false;

  // Attach the embed only once the modal is on screen, so a YouTube/Vimeo
  // player is never loaded by a dashboard the creator closes straight away.
  // The body class is what lets the stylesheet frost this modal's backdrop
  // without touching every other modal's.
  modal.addEventListener('show.bs.modal', function () {
    document.body.classList.add('creator-tutorial-open');

    if (frame && !frame.src && frame.dataset.src) {
      frame.src = frame.dataset.src;
    }
  });

  // Nothing should keep playing behind the dashboard.
  modal.addEventListener('hide.bs.modal', function () {
    if (video) video.pause();
    if (frame && frame.src) frame.src = '';
  });

  modal.addEventListener('hidden.bs.modal', function () {
    document.body.classList.remove('creator-tutorial-open');

    if (!optOut?.checked || dismissSent || !endpoint || !window.axios) return;

    dismissSent = true;
    window.axios.post(endpoint).catch(function () {
      // A failed save only costs the creator one more popup, so it is not worth
      // an error toast over a tutorial. Allow a retry on the next close.
      dismissSent = false;
    });
  });

  confirmButton?.addEventListener('click', function () {
    window.bootstrap.Modal.getOrCreateInstance(modal).hide();
  });

  window.bootstrap.Modal.getOrCreateInstance(modal, { keyboard: true }).show();
}

document.addEventListener('DOMContentLoaded', initCreatorTutorial);
